var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "gallery-view" },
    [
      _c(
        "gallery-view-toolbar",
        {
          attrs: {
            editable: _vm.editable,
            event: _vm.event,
            sensorType: _vm.sensorType,
            canDownload: !_vm.event.updating,
            downloadOptions: _vm.downloadOptions,
            title: _vm.title,
          },
          on: {
            download: _vm.download,
            update: function (attr) {
              return _vm.$emit("updateEvent", attr)
            },
            close: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _vm.editable && !_vm.event.updating
            ? _c(
                "toolbar-button",
                {
                  attrs: { icon: "fa-trash" },
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.$emit("deleteEvent")
                    },
                  },
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("menu.delete")) + "\n    ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "layout",
        {
          staticClass: "mb-3",
          attrs: { hasPrevious: _vm.hasPrevious, hasNext: _vm.hasNext },
          on: {
            previous: function ($event) {
              return _vm.$emit("previous")
            },
            next: function ($event) {
              return _vm.$emit("next")
            },
          },
          scopedSlots: _vm._u([
            {
              key: "top",
              fn: function () {
                return [
                  _c("gallery-view-header", {
                    attrs: { editable: _vm.editable, event: _vm.event },
                    on: {
                      updateEvent: function ($event) {
                        return _vm.$emit("updateEvent", $event)
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "side",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "result mb-2" },
                    [
                      _c(
                        "v-row",
                        {
                          attrs: {
                            "no-gutters": "",
                            align: "center",
                            justify: "end",
                          },
                        },
                        [
                          _c("v-checkbox", {
                            staticClass: "mt-0 ml-3 mr-auto",
                            attrs: {
                              label: _vm.$t("field.original"),
                              "hide-details": "",
                              color: "primary",
                            },
                            model: {
                              value: _vm.viewOriginal,
                              callback: function ($$v) {
                                _vm.viewOriginal = $$v
                              },
                              expression: "viewOriginal",
                            },
                          }),
                          _vm._v(" "),
                          _c("chart-type-select", {
                            model: {
                              value: _vm.chartType,
                              callback: function ($$v) {
                                _vm.chartType = $$v
                              },
                              expression: "chartType",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.chartType == "table"
                        ? _c("insect-count-table", {
                            attrs: {
                              insectCounts: _vm.event.insect_counts,
                              showRadiobutton: !_vm.event.updating,
                              pickedDetectionType: _vm.pickedDetectionType,
                              showFocusButton: "",
                              tableMaxHeight: "65vh",
                            },
                            on: {
                              "update:pickedDetectionType": function ($event) {
                                _vm.pickedDetectionType = $event
                              },
                              "update:picked-detection-type": function (
                                $event
                              ) {
                                _vm.pickedDetectionType = $event
                              },
                              "click:focus": _vm.handleFocus,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.chartType == "bar"
                        ? _c("insect-count-by-type-bar-chart", {
                            attrs: { insectCounts: _vm.event.insect_counts },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.chartType == "pie"
                        ? _c("top-5-insect-types-pie-chart", {
                            attrs: { insectCounts: _vm.event.insect_counts },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "result pa-2" },
                    [
                      _c(
                        "div",
                        { staticClass: "pt-2 px-2" },
                        [
                          _c("div", { staticClass: "result-item" }, [
                            _c("span", [_vm._v(_vm._s(_vm.$t("field.total")))]),
                            _vm._v(" "),
                            _c("span", { staticClass: "mx-1" }, [_vm._v(":")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.event.count))]),
                          ]),
                          _vm._v(" "),
                          _c("insect-count-difference", {
                            staticClass: "result-item",
                            attrs: { event: _vm.event },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("threshold-alert-status", {
                        staticClass: "pa-2",
                        attrs: { event: _vm.event, editable: _vm.editable },
                        on: {
                          updateThreshold: function ($event) {
                            return _vm.$emit("updateThreshold", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "gallery-view__image" },
            [
              _c("picked-insects-draw", {
                ref: "drawer",
                attrs: {
                  imageSrc: _vm.event.attachments["display-photo"],
                  detectionsUrl: _vm.detectionsUrl,
                  hideCanvas: _vm.viewOriginal,
                  pickedDetectionType: _vm.pickedDetectionType,
                  originalImageWidth: _vm.ORIGINAL_IMAGE_WIDTH,
                  originalImageHeight: _vm.ORIGINAL_IMAGE_HEIGHT,
                },
                on: { save: _vm.save },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-center" },
            [
              _c("replacement-notification", {
                staticClass: "mt-3",
                attrs: {
                  trap_replaced_on: _vm.trap_replaced_on,
                  trap_effective_days: _vm.trap_effective_days,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm._t("thumbnails"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }